/*
  ProBrush PDP v1
  - Leveringsestimat: altid dansk tid (Europe/Copenhagen), kun hverdage,
    danske helligdage beregnes automatisk, ekstra lukkedage via temaindstilling.
  - Opdaterer fragt- og leveringslinjer ved variantskift.
*/
(function () {
  if (window.PBPdp) return;

  var TZ = 'Europe/Copenhagen';
  var DAY = 86400000;

  function nowInCopenhagen() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    })
      .formatToParts(new Date())
      .forEach(function (p) {
        parts[p.type] = p.value;
      });
    return {
      date: utcDate(+parts.year, +parts.month, +parts.day),
      seconds: (+parts.hour % 24) * 3600 + +parts.minute * 60 + +parts.second
    };
  }

  function utcDate(y, m, d) {
    return new Date(Date.UTC(y, m - 1, d));
  }

  function addDays(date, n) {
    return new Date(date.getTime() + n * DAY);
  }

  function isoKey(date) {
    return date.toISOString().slice(0, 10);
  }

  // Gregoriansk påskeberegning (anonym algoritme)
  function easter(y) {
    var a = y % 19,
      b = Math.floor(y / 100),
      c = y % 100,
      d = Math.floor(b / 4),
      e = b % 4,
      f = Math.floor((b + 8) / 25),
      g = Math.floor((b - f + 1) / 3),
      h = (19 * a + b - d - g + 15) % 30,
      i = Math.floor(c / 4),
      k = c % 4,
      l = (32 + 2 * e + 2 * i - h - k) % 7,
      m = Math.floor((a + 11 * h + 22 * l) / 451),
      month = Math.floor((h + l - 7 * m + 114) / 31),
      day = ((h + l - 7 * m + 114) % 31) + 1;
    return utcDate(y, month, day);
  }

  var holidayCache = {};
  function danishHolidays(y) {
    if (holidayCache[y]) return holidayCache[y];
    var e = easter(y);
    holidayCache[y] = [
      utcDate(y, 1, 1), // Nytårsdag
      addDays(e, -3), // Skærtorsdag
      addDays(e, -2), // Langfredag
      e, // Påskedag
      addDays(e, 1), // 2. påskedag
      addDays(e, 39), // Kristi himmelfartsdag
      addDays(e, 49), // Pinsedag
      addDays(e, 50), // 2. pinsedag
      utcDate(y, 12, 25), // Juledag
      utcDate(y, 12, 26) // 2. juledag
    ].map(isoKey);
    return holidayCache[y];
  }

  function isWeekend(date) {
    var dow = date.getUTCDay();
    return dow === 0 || dow === 6;
  }

  function isHoliday(date, extra) {
    var key = isoKey(date);
    return danishHolidays(date.getUTCFullYear()).indexOf(key) > -1 || extra.indexOf(key) > -1;
  }

  function isShippingDay(date, extra) {
    return !isWeekend(date) && !isHoliday(date, extra);
  }

  function nextShippingDay(from, extra) {
    var d = from;
    for (var i = 0; i < 60; i++) {
      if (isShippingDay(d, extra)) return d;
      d = addDays(d, 1);
    }
    return d;
  }

  function addShippingDays(from, n, extra) {
    var d = from,
      count = 0;
    while (count < n) {
      d = addDays(d, 1);
      if (isShippingDay(d, extra)) count++;
    }
    return d;
  }

  function addCarrierDays(from, n, extra, weekendDelivery) {
    if (!weekendDelivery) return addShippingDays(from, n, extra);
    var d = from,
      count = 0;
    while (count < n) {
      d = addDays(d, 1);
      if (!isHoliday(d, extra)) count++;
    }
    return d;
  }

  function compute(cfg) {
    var now = nowInCopenhagen();
    var cutoffSeconds = cfg.cutoff * 3600;
    var shipsToday = isShippingDay(now.date, cfg.closed) && now.seconds < cutoffSeconds;
    var shipDate = shipsToday ? now.date : nextShippingDay(addDays(now.date, 1), cfg.closed);
    return {
      today: now.date,
      shipsToday: shipsToday,
      secondsLeft: shipsToday ? cutoffSeconds - now.seconds : 0,
      shipDate: shipDate,
      earliest: addCarrierDays(shipDate, cfg.minDays, cfg.closed, cfg.weekendDelivery),
      latest: addShippingDays(shipDate, cfg.maxDays, cfg.closed)
    };
  }

  // Formatering (dansk)
  var fmtWeekdayLong = new Intl.DateTimeFormat('da-DK', { weekday: 'long', timeZone: 'UTC' });
  var fmtWeekdayShort = new Intl.DateTimeFormat('da-DK', { weekday: 'short', timeZone: 'UTC' });
  var fmtMonthShort = new Intl.DateTimeFormat('da-DK', { month: 'short', timeZone: 'UTC' });

  function shortWeekday(date) {
    return fmtWeekdayShort.format(date).replace(/\.$/, '') + '.';
  }

  // da-DK giver "okt.", "jun.", "maj" osv.
  function monthShort(date) {
    return fmtMonthShort.format(date);
  }

  function dayLabel(date, withMonth) {
    return shortWeekday(date) + ' ' + date.getUTCDate() + '.' + (withMonth ? ' ' + monthShort(date) : '');
  }

  function rangeLabel(a, b) {
    if (isoKey(a) === isoKey(b)) return dayLabel(a, true);
    var sameMonth = a.getUTCMonth() === b.getUTCMonth();
    return dayLabel(a, !sameMonth) + ' til ' + dayLabel(b, true);
  }

  function shipDayLabel(state) {
    var diff = Math.round((state.shipDate - state.today) / DAY);
    if (diff === 1) return 'i morgen';
    if (diff < 7) return fmtWeekdayLong.format(state.shipDate);
    return fmtWeekdayLong.format(state.shipDate) + ' d. ' + dayLabel(state.shipDate, true).replace(/^\S+ /, '');
  }

  function countdownLabel(seconds) {
    var h = Math.floor(seconds / 3600);
    var m = Math.max(1, Math.ceil((seconds % 3600) / 60));
    if (m === 60) {
      h += 1;
      m = 0;
    }
    if (h === 0) return m + ' min.';
    return h + ' t.' + (m ? ' ' + m + ' min.' : '');
  }

  function fill(template, token, value) {
    var safe = String(value).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
    return template.replace(token, '<strong>' + safe + '</strong>');
  }

  function parseClosed(raw) {
    return (raw || '')
      .split(/[\s,;]+/)
      .map(function (s) {
        return s.trim();
      })
      .filter(function (s) {
        return /^\d{4}-\d{2}-\d{2}$/.test(s);
      });
  }

  function renderDelivery(el) {
    var cfg = {
      cutoff: parseInt(el.dataset.cutoff, 10) || 14,
      closed: parseClosed(el.dataset.closed),
      minDays: parseInt(el.dataset.minDays, 10) || 1,
      maxDays: parseInt(el.dataset.maxDays, 10) || 3,
      weekendDelivery: el.dataset.weekendDelivery === 'true'
    };
    var state = compute(cfg);
    var shipEl = el.querySelector('[data-pb-ship]');
    var etaEl = el.querySelector('[data-pb-eta]');

    if (shipEl) {
      shipEl.innerHTML = state.shipsToday
        ? fill(el.dataset.textOpen, '[countdown]', countdownLabel(state.secondsLeft))
        : fill(el.dataset.textClosed, '[day]', shipDayLabel(state));
    }
    if (etaEl) {
      etaEl.innerHTML = fill(el.dataset.textEta, '[range]', rangeLabel(state.earliest, state.latest));
    }
    el.classList.add('pb-delivery--ready');
  }

  function renderAll() {
    document.querySelectorAll('[data-pb-delivery]').forEach(renderDelivery);
  }

  function onVariantChange(variant) {
    if (!variant) return;
    document.querySelectorAll('[data-pb-offer]').forEach(function (el) {
      el.dataset.variant = variant.id;
      offerTick(el);
    });
    document.querySelectorAll('[data-pb-delivery]').forEach(function (el) {
      el.hidden = variant.available === false;
    });
    document.querySelectorAll('[data-pb-assurance]').forEach(function (el) {
      var threshold = parseInt(el.dataset.threshold, 10) || 0;
      var free = variant.price >= threshold;
      var freeEl = el.querySelector('[data-pb-ship-free]');
      var paidEl = el.querySelector('[data-pb-ship-paid]');
      if (freeEl) freeEl.hidden = !free;
      if (paidEl) paidEl.hidden = free;
    });
  }

  // ---------- Kampagne: nedtælling og lager ----------
  function tzOffsetMs(utcMs) {
    var p = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date(utcMs)).forEach(function (x) { p[x.type] = x.value; });
    return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second) - utcMs;
  }

  // "2026-10-18 23:59" (dansk tid) -> epoch ms
  function parseDk(str) {
    var m = /^\s*(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2})[:.](\d{2}))?\s*$/.exec(str || '');
    if (!m) return null;
    var guess = Date.UTC(+m[1], +m[2] - 1, +m[3], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59, m[4] ? 0 : 59);
    var t = guess - tzOffsetMs(guess);
    return t - (tzOffsetMs(t) - tzOffsetMs(guess));
  }

  // Produktmetafelt (dato og klokkeslæt) leveres som epoch-sekunder, ellers dansk tekstdato
  function readTime(el, key) {
    var ts = el.dataset[key + 'Ts'];
    if (ts && /^\d+$/.test(ts)) return +ts * 1000;
    return parseDk(el.dataset[key]);
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function offerTick(el) {
    var now = Date.now();
    var start = readTime(el, 'start');
    var end = readTime(el, 'end');
    var style = el.dataset.style;
    var timed = !!end;
    if ((start && now < start) || (timed && now >= end) || (!timed && style !== 'stock')) {
      el.hidden = true;
      return false;
    }
    if (timed) {
      var left = Math.max(0, Math.floor((end - now) / 1000));
      var d = Math.floor(left / 86400), h = Math.floor((left % 86400) / 3600), mi = Math.floor((left % 3600) / 60), se = left % 60;
      var map = { d: d, h: pad(h), m: pad(mi), s: pad(se) };
      el.querySelectorAll('[data-u]').forEach(function (u) { u.textContent = map[u.dataset.u]; });
      var inline = el.querySelector('[data-pb-offer-inline]');
      if (inline) inline.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + 't ' + pad(mi) + 'm ' + pad(se) + 's';
    }
    if (style === 'stock' && !offerStock(el)) {
      el.hidden = true;
      return true;
    }
    el.hidden = false;
    return true;
  }

  function offerStock(el) {
    var stock = {};
    try { stock = JSON.parse(el.dataset.stock || '{}'); } catch (e) {}
    var qty = stock[el.dataset.variant];
    var threshold = parseInt(el.dataset.stockThreshold, 10) || 0;
    var startQty = parseInt(el.dataset.stockStart, 10) || 0;
    var textEl = el.querySelector('[data-pb-offer-stock-text]');
    var bar = el.querySelector('[data-pb-offer-stockbar]');
    if (qty === undefined || qty < 0 || qty === 0) return false; // ukendt lager eller udsolgt: vis intet
    if (textEl) {
      textEl.innerHTML = qty <= threshold
        ? 'Kun <strong>' + qty + ' stk.</strong> tilbage til tilbudsprisen'
        : '<strong>' + qty + ' stk.</strong> tilbage til tilbudsprisen';
    }
    if (bar) {
      if (startQty > 0 && qty <= startQty) {
        var sold = Math.round(((startQty - qty) / startQty) * 100);
        bar.hidden = false;
        bar.querySelector('span').style.width = Math.max(4, sold) + '%';
        bar.setAttribute('aria-label', sold + ' % af kampagnelageret er solgt');
      } else {
        bar.hidden = true;
      }
    }
    return true;
  }

  function offersAll() {
    document.querySelectorAll('[data-pb-offer]').forEach(offerTick);
  }

  function init() {
    offersAll();
    setInterval(offersAll, 1000);
    renderAll();
    setInterval(renderAll, 30000);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) renderAll();
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        onVariantChange(event && event.data && event.data.variant);
      });
    }
  }

  window.PBPdp = { compute: compute, render: renderAll, _internals: { parseDk: parseDk, easter: easter, danishHolidays: danishHolidays, rangeLabel: rangeLabel, countdownLabel: countdownLabel, shipDayLabel: shipDayLabel } };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
